"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Overlay = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const styled_tools_1 = require("styled-tools");
const Hidden_1 = require("./Hidden");
exports.Overlay = styled_1.default(Hidden_1.Hidden) `
  position: fixed;
  z-index: 19900410;
  left: 50%;
  top: 50%;
  ${styled_tools_1.theme('Overlay')};
`;
exports.Overlay.defaultProps = {
    role: 'dialog',
    'aria-modal': true,
    hideOnEsc: true,
    translateX: '-50%',
    translateY: '-50%',
    defaultSlide: 'top',
    opaque: true,
    palette: 'background',
    tone: -1,
};

//# sourceMappingURL=Overlay.js.map
